import { Chip, ChipProps } from "@mui/material"
import { ResearchResult } from "interface/research"

type ResearchReportTypeChipProps = {
  reportType: ResearchResult["reportType"]
} & ChipProps
export const ResearchReportTypeChip = ({
  reportType,
  ...others
}: ResearchReportTypeChipProps) => {
  return (
    <Chip label={reportType} {...others}/>
  )
}
